import { Tooltip } from 'antd';
import { AbstractTooltipProps } from 'antd/lib/tooltip';
import classNames from 'classnames';
import { getHashedColor } from 'utils/color';
import './ComparisonBadge.less';

type BadgeColor =
  | 'C54307C'
  | 'C8F278E'
  | 'CE11C46'
  | 'CED3180'
  | 'CA32C31'
  | 'CEC1943'
  | 'CB4292F'
  | 'CEF5440'
  | 'CB04331'
  | 'CF48D33'
  | 'CD3622A'
  | 'CF3A147'
  | 'CBEB132'
  | 'CD5D725'
  | 'C00A14B'
  | 'C83C343'
  | 'C009B4F'
  | 'C22B35F'
  | 'C0070A3'
  | 'C00AEDF'
  | 'C293F81'
  | 'C0087CB'
  | 'C2E3191'
  | 'C563091';
interface Props extends AbstractTooltipProps {
  name: string;
  color?: BadgeColor;
}

const ComparisonBadge = ({ name, color, ...props }: Props) => {
  return (
    <Tooltip {...props} title={name}>
      <span
        className={classNames('comparison-badge', color)}
        style={color ? {} : { backgroundColor: getHashedColor(name) }}
      >
        <span>{name}</span>
      </span>
    </Tooltip>
  );
};

const COMPARISON_BADGE_COLORS: BadgeColor[] = [
  'C54307C',
  'C8F278E',
  'CE11C46',
  'CED3180',
  'CA32C31',
  'CEC1943',
  'CB4292F',
  'CEF5440',
  'CB04331',
  'CF48D33',
  'CD3622A',
  'CF3A147',
  'CBEB132',
  'CD5D725',
  'C00A14B',
  'C83C343',
  'C009B4F',
  'C22B35F',
  'C0070A3',
  'C00AEDF',
  'C293F81',
  'C0087CB',
  'C2E3191',
  'C563091',
];
const getComparisonBadgeColor = (index: number) => {
  return COMPARISON_BADGE_COLORS[index % COMPARISON_BADGE_COLORS.length];
};

export { getComparisonBadgeColor, ComparisonBadge, COMPARISON_BADGE_COLORS };

export default ComparisonBadge;
